<template>
	<div class="grid grid-cols-1 gap-6 md:grid-cols-2">
		<div
			v-for="(product, index) in products"
			:key="index"
			class="contained-section flex flex-col justify-between bg-white md:px-8 md:py-10"
		>
			<div>
				<p>Related product</p>
				<h3>{{ product.title }}</h3>
				<p>{{ product.desc }}</p>
			</div>
			<div class="mt-8">
				<CarbarLink
					:underline="false"
					class="w-full md:min-w-fit"
					:href="product.href"
				>
					<CarbarButton :is-full-width="false">
						{{ product.cta }}
					</CarbarButton>
				</CarbarLink>
			</div>
		</div>
	</div>
</template>

<script setup>
import CarbarLink from '@/components/links/CarbarLink.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'

const props = defineProps({
	title1: {
		type: String,
		required: true,
	},
	desc1: {
		type: String,
		required: true,
	},
	cta1: {
		type: String,
		required: true,
	},
	href1: {
		type: String,
		required: true,
	},
	title2: {
		type: String,
		required: true,
	},
	desc2: {
		type: String,
		required: true,
	},
	cta2: {
		type: String,
		required: true,
	},
	href2: {
		type: String,
		required: true,
	},
})

const products = computed(() => [
	{
		title: props.title1,
		desc: props.desc1,
		href: props.href1,
		cta: props.cta1,
	},
	{
		title: props.title2,
		desc: props.desc2,
		href: props.href2,
		cta: props.cta2,
	},
])
</script>
